// extracted by mini-css-extract-plugin
var _1 = "ExternalTopbar-module__actions--utmOZ";
var _2 = "ExternalTopbar-module__animateUploadProgressBarWidth--XPc_F";
var _3 = "ExternalTopbar-module__animatedBackground--jtaOV";
var _4 = "ExternalTopbar-module__caret--bcX6T";
var _5 = "ExternalTopbar-module__editingNote--s8nS0";
var _6 = "ExternalTopbar-module__externalTopbar--d7TY2";
var _7 = "ExternalTopbar-module__isActive--XRKQv";
var _8 = "ExternalTopbar-module__isPopOverOpen--uttz0";
var _9 = "ExternalTopbar-module__link--Adxy5";
var _a = "ExternalTopbar-module__loading--YrswC";
var _b = "ExternalTopbar-module__logo--jtEsA";
var _c = "ExternalTopbar-module__mobileNavigationButton--ydm1P";
var _d = "ExternalTopbar-module__modeToggleSeparator--AGS_z";
var _e = "ExternalTopbar-module__navigation--dOOjN";
var _f = "ExternalTopbar-module__publicLogo--mBWMB";
var _10 = "ExternalTopbar-module__teamIconLink--C7H7K";
var _11 = "ExternalTopbar-module__topbarMenu--QPVuq";
var _12 = "ExternalTopbar-module__trySlab--DsU2Y";
var _13 = "ExternalTopbar-module__trySlabDescription--KNnIi";
var _14 = "ExternalTopbar-module__trySlabLogo--ZUJcW";
var _15 = "ExternalTopbar-module__trySlabTitle--OSc8A";
export { _1 as "actions", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "caret", _5 as "editingNote", _6 as "externalTopbar", _7 as "isActive", _8 as "isPopOverOpen", _9 as "link", _a as "loading", _b as "logo", _c as "mobileNavigationButton", _d as "modeToggleSeparator", _e as "navigation", _f as "publicLogo", _10 as "teamIconLink", _11 as "topbarMenu", _12 as "trySlab", _13 as "trySlabDescription", _14 as "trySlabLogo", _15 as "trySlabTitle" }
